// src/routes/couponsRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Coupons from '../pages/coupons/Coupons';
import CreateCoupon from '../pages/coupons/CreateCoupon';
import EditCoupon from '../pages/coupons/EditCoupon';
import ProtectedRoute from '../components/global/ProtectedRoute';

const couponsRoutes = (
    <>
        {/* Coupons List */}
        <Route
            path="/coupons"
            element={
                <ProtectedRoute requiredPermission="promotions.manage">
                    <Coupons />
                </ProtectedRoute>
            }
        />

        {/* Create Coupon */}
        <Route
            path="/coupons/create"
            element={
                <ProtectedRoute requiredPermission="promotions.manage">
                    <CreateCoupon />
                </ProtectedRoute>
            }
        />

        {/* Edit Coupon */}
        <Route
            path="/coupons/:id/edit"
            element={
                <ProtectedRoute requiredPermission="promotions.manage">
                    <EditCoupon />
                </ProtectedRoute>
            }
        />
    </>
);

export default couponsRoutes;
